import { ConfigData, GoogleUser, MicrosoftUser, User } from '../../firebase/firestore/documents/user';
import { TimezoneType } from '../../modules/profile/ProfileTypes';

export interface CurrentUserProfile {
  readonly id: string;
  readonly account: string;
}

export class CurrentUserProfilePresenter implements CurrentUserProfile {
  constructor(private readonly user: User) {}

  get id(): string {
    return this.user.id;
  }

  get fullName(): string {
    return `${this.user.firstName} ${this.user.lastName ?? ''}`;
  }

  get account(): string {
    return this.user.account;
  }

  get email(): string {
    return this.user.email;
  }

  get locale(): string {
    return this.user.locale;
  }

  get config(): ConfigData | undefined {
    return this.user.config;
  }

  get googleCalendar(): GoogleUser[] | undefined {
    return this.user.googleCalendar;
  }

  get microsoftCalendar(): MicrosoftUser[] | undefined {
    return this.user.microsoftCalendar;
  }

  // istanbul ignore next
  get filterCandidateByDays(): number | undefined {
    return this.user.filterCandidateByDays;
  }

  // istanbul ignore next
  get enabledNewApiForCandidates(): boolean | undefined {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.user.enabledNewApiForCandidates;
  }

  get primaryTimezone(): TimezoneType | undefined {
    return this.user.primaryTimezone;
  }

  get secondaryTimezone(): TimezoneType | undefined {
    return this.user.secondaryTimezone;
  }

  get isSecondaryTimezoneEnabled(): boolean {
    return this.user.isSecondaryTimezoneEnabled ?? false;
  }
}
